import { useFindAllFeatureFlags } from './data';

export enum Feature {
  VENDOR_CHECK_REQUIRED = 'vendor_check_required',
}

export const useFeatureFlags = () => {
  const { data, isFetching, isPending } = useFindAllFeatureFlags();

  const isFeatureEnabled = (key: string): boolean => {
    return !!data?.some((x) => x.key.toLowerCase() === key.toLowerCase() && x.isEnabled);
  };

  return { isFeatureEnabled, isFetching, isPending };
};
